import type { RouteObject } from 'react-router';

import { BASE, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import { generatePageWithTabsRoute } from './routeGenerator';
import { summaryRouteDefinitions } from './SummaryRouteDefinitions';

const SummaryRoutes: RouteObject = generatePageWithTabsRoute(
  'Overview of performance across your portfolio',
  BASE.SUMMARY,
  NESTED_ROUTES.SUMMARY.HOMEPAGE,
  summaryRouteDefinitions,
);

export default SummaryRoutes;
